import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-88326b3e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"content\" data-v-88326b3e><div class=\"head\" data-v-88326b3e><div class=\"cover\" style=\"background:rgb(28, 27, 89);\" data-v-88326b3e></div><img src=\"https://media.kommunity.com/communities/tracikkaynak/19055/acik-kaynak-platformu.jpg?p=avatar-120\" alt=\"\" data-v-88326b3e></div><div class=\"wrapper\" data-v-88326b3e><div class=\"title\" data-v-88326b3e><h1 data-v-88326b3e>Türkiye Açık Kaynak Platformu</h1><span data-v-88326b3e>Istanbul • 12137 üyeler</span></div><div class=\"submit\" data-v-88326b3e><button data-v-88326b3e>Topluluğa Katıl</button></div></div></div>", 1)

import SectionCard from "./SectionCard.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'SectionContent',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode(SectionCard)
    ])
  ]))
}
}

})